import { ROLES } from "../config/accessEnum";

// Statuts d'une demande de financement (valeurs API, cf. cycle-de-vie-demande.md).
export const STATUT_ACCORD_RECU = 3;
export const STATUT_ABANDONNEE = 7;

const ROLES_GESTIONNAIRES = [ROLES.ADMIN, ROLES.SUPER_ADMIN];

// LS-607 — les gestionnaires (Admin / Super-admin) ne sont jamais verrouillés.
export const estGestionnaire = (role) => ROLES_GESTIONNAIRES.includes(role);

// LS-612 — saisie de l'échéancier réel (mensualité retenue par palier, date de
// début) possible dès Accord reçu (3), indépendamment du verrouillage classique
// de la demande, et à tout moment ensuite (Transmis et signé compris).
// LS-629 — sauf demande abandonnée (7), jamais ressaisissable.
// LS-724 — réservée aux gestionnaires : un commercial ne saisit jamais
// d'échéancier, quel que soit le statut (l'API répond 403).
export const peutSaisirEcheancier = (status, role) =>
  estGestionnaire(role) &&
  Number(status) >= STATUT_ACCORD_RECU &&
  Number(status) !== STATUT_ABANDONNEE;
